import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ScreenSizeService } from "../../../services/screen-size.service";

@Component({
  selector: 'app-welcome-screen',
  templateUrl: './welcome-screen.component.html',
  styleUrls: ['./welcome-screen.component.css']
})
export class WelcomeScreenComponent {

  isMobile: boolean = false;

  constructor(
    private router: Router,
    private screenSizeService: ScreenSizeService
  ) {}

  ngOnInit(): void {
    this.screenSizeService.isMobile$.subscribe(isMobile => {
      this.isMobile = isMobile;
    });
  }


  navigateTo(path: string, mode: string) {
    this.router.navigate([path], { queryParams: { mode } });
  }
}
